"use client";

/**
 * Ported from the source project's `components/organisms/Spinner` — the same
 * two-arc SVG, so the catalogue's loading state and the Apply Now form's read
 * identically.
 *
 * `color` is a text-colour CLASS, not a hex value, because the arcs are drawn
 * with `stroke`/`fill: currentColor`. The default is the source's `text-gray-500`
 * token, which that project remaps to #B8B8B8.
 */
export default function Spinner({
  size = "h-6 w-6",
  color = "text-[#B8B8B8]",
}: {
  size?: string;
  color?: string;
}) {
  return (
    <svg
      className={`animate-spin ${size} ${color}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      role="status"
      aria-label="Loading"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  );
}
